export const MESSAGES_BASE_SPACING = 0;
export const MASK_FADE_HEIGHT = 80;
export const MASK_FADE_HEIGHT_SHARE_UNAUTH = 120;
export const MASK_FADE_HEIGHT_MOBILE = 56;
export const MASK_BUFFER = 0;

export const HEADER_HEIGHTS = {
    MOBILE_AUTH: 56,
    MOBILE_UNAUTH: 56,
    DESKTOP_AUTH: 48,
    MOBILE_BUFFER: 12,
};

export const getHeaderHeight = (isMobile, authenticated) => {
    if (isMobile && authenticated) return HEADER_HEIGHTS.MOBILE_AUTH;
    if (!authenticated) return HEADER_HEIGHTS.MOBILE_UNAUTH;
    if (!isMobile) return HEADER_HEIGHTS.DESKTOP_AUTH;
    return 0;
};

export const getMobilePaddingTop = (isMobile) => (isMobile ? HEADER_HEIGHTS.MOBILE_BUFFER : 0);
